import {
  Box,
  Flex,
  Link,
  Text,
} from '@chakra-ui/react';
import { QUARTERS } from '@src/modules/performance/shared/constants';

import { roundKpiValue } from '@src/modules/performance/shared/helpers';
import { useTemporaryTrafficManagementKpi } from '@src/modules/performance/context/temporary-traffic-management-api-hooks';
import ReportHeader from './ReportHeader';

const subheader = 'TTM cost as a percentage of NLTP';

const informationSource = {
  title: 'Temporary Traffic Management',
  content: [
    {
      title: 'YTD NLTP Expenditure (%)',
      description:
  <Text fontSize="inherit" mb={2}>
    The year-to-date TTM cost as a percentage of the year-to-date NLTP expenditure.
    Reported for the latest quarter results that have been released by the NZTA Board and the Minister of Transport.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    All results provided by the RCAs.
    <br />
    Guidance for RCAs on recording their results is provided on the NZTA
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/planning/road-efficiency-group/transport-insights-and-performance-reporting/temporary-traffic-management-reporting/" isExternal>NZTA Temporary traffic management reporting page.</Link>
  </Text>,
    },
  ],
};

function TemporaryTrafficManagementReportHeader({ ...rest }) {
  const { data: ttmKpiData, isLoading } = useTemporaryTrafficManagementKpi();

  return (
    <ReportHeader
      title="Temporary Traffic Management"
      subtitle={subheader}
      informationSource={informationSource}
      {...rest}
    >
      {ttmKpiData?.value && ttmKpiData?.value !== null && !isLoading && (
      <Flex align="center" ml={4}>
        <Box mr={3}>
          <Text
            colour={ttmKpiData?.value !== undefined ? 'gray.700' : null}
            fontSize={36}
            textAlign="center"
          >
            {roundKpiValue(ttmKpiData?.value, 7, 1)}
            %
          </Text>
        </Box>
        <Box>
          <Text fontWeight="bold" color="gray" fontSize="sm">
            % of YTD NLTP Expenditure
            <br />
            <Text as="span" fontSize="xs" color="gray">
              as at
              {' '}
              {QUARTERS.find((q) => q.id === parseInt(ttmKpiData?.quarter, 10))?.label}
              {' '}
              {ttmKpiData?.quadLockYear}
            </Text>
          </Text>
        </Box>
      </Flex>
      )}
    </ReportHeader>
  );
}

export default TemporaryTrafficManagementReportHeader;
